import { render } from "./DevelopIndex.vue?vue&type=template&id=218a851c&scoped=true"
import script from "./DevelopIndex.vue?vue&type=script&lang=js"
export * from "./DevelopIndex.vue?vue&type=script&lang=js"

import "./DevelopIndex.vue?vue&type=style&index=0&id=218a851c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218a851c"]])

export default __exports__